export var scenesLayers = [{
  id: 'Scene',
  type: 'sceneReady',
  event: true
}];